/* eslint-disable react-hooks/exhaustive-deps */
import { ContentLayout, CustomTable, HeaderBreadcrumbs, useFormatAmount } from "../../../shared";
import React from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import InputControl from "../../../shared/components/InputControl";
import { arraySort, sortItems } from "../../../utils";
import AddIcon from "@mui/icons-material/Add";
import { useClientAccountList } from "../hooks";
import { useStore } from "../../Stores";
import { ClientAccountRequestList } from "../components";

export const ClientAccountsList = () => {
  const navigate = useNavigate();
  const formatAmount = useFormatAmount();

  const {
    state,
    isEditable,
    isCreateVisible,
    isStoreAdmin,
    handleFilterClear,
    onSeachClear,
    onChangeFilter,
    handleFilter,
    handleApplyFilter,
  } = useClientAccountList({
    isList: true,
  });
  const { storeList } = useStore({
    isStore: isStoreAdmin ? false : true,
    storeId: null,
  });

  const { isLoading, dataList } = state;

  const storeOptions = storeList.map((v) => {
    return { value: v.id, label: v.name };
  });

  const ActionButtons = ({ id }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.stopPropagation()}>
        <img
          onClick={() =>
            navigate(
              isStoreAdmin
                ? `/store-admin/client-account-v2/details/${id}`
                : `/client-account-v2/details/${id}`
            )
          }
          alt="details"
          src="/icons/arrow_forward.svg"
        />
      </div>
    );
  };
  const storeAdmincolumns = React.useMemo(
    () => [
      {
        Header: "Account No",
        accessor: "number",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Client Account Name",
        accessor: "account_name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Contact No.",
        accessor: "phone_numbers",
        disableSortBy: true,
        Cell: ({ value }) => {
          const defaultPhone = value?.find((data) => data.is_default === 1);
          const extraPhones = value?.filter((data) => data !== defaultPhone);

          return (
            <Stack
              sx={{
                flexDirection: "row",
                gap: "8px",
                flexWrap: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {defaultPhone && (
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {defaultPhone.phone}
                </div>
              )}

              {extraPhones?.length > 0 && (
                <Tooltip
                  title={
                    <Box component="ul" sx={{ margin: 0, padding: '4px 8px', listStyle: 'none' }}>
                      {extraPhones.map((data, index) => (
                        <li key={index}>{data.phone}</li>
                      ))}
                    </Box>
                  }
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#192029',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#192029',
                      },
                    },
                  }}
                  arrow
                >
                  <Chip
                    sx={{ borderRadius: "8px", flexShrink: 0 }}
                    label={`+${extraPhones.length}`}
                    variant="filled"
                    size="small"
                  />
                </Tooltip>
              )}
            </Stack>
          );
        },
      },
      {
        Header: "Email ID",
        accessor: "emails",
        disableSortBy: true,
        Cell: ({ value }) => {
          const defaultEmail = value?.find((data) => data.is_default === 1);
          const extraEmail = value?.filter((data) => data !== defaultEmail);

          return (
            <Stack
              sx={{
                flexDirection: "row",
                gap: "8px",
                flexWrap: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {defaultEmail && (
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {defaultEmail.email}
                </div>
              )}

              {extraEmail?.length > 0 && (
                <Tooltip
                  title={
                    <Box component="ul" sx={{ margin: 0, padding: '4px 8px', listStyle: 'none' }}>
                      {extraEmail.map((data, index) => (
                        <li key={index}>{data.email}</li>
                      ))}
                    </Box>
                  }
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#192029',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#192029',
                      },
                    },
                  }}
                  arrow
                >
                  <Chip
                    sx={{ borderRadius: "8px", flexShrink: 0 }}
                    label={`+${extraEmail.length}`}
                    variant="filled"
                    size="small"
                  />
                </Tooltip>
              )}
            </Stack>
          );
        },
      },
      {
        Header: "Credit Limit",
        accessor: "credit_limit",
        Cell: ({ value }) => {
          return <div>{formatAmount(value)}</div>;
        },
      },
      {
        Header: "Total Due Amount",
        accessor: "due_amount",
        Cell: ({ value }) => {
          return <div>{formatAmount(value)}</div>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        sortInverted: true,
        Cell: ({ value }) => {
          return value ? (
            <Chip
              label="Active"
              color="success"
              variant="outlined"
              size="small"
            />
          ) : (
            <Chip
              label="Inactive"
              color="success"
              variant="outlined"
              size="small"
              disabled
            />
          );
        },
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableGlobalFilter: true,
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons id={row.id} />;
        },
      },
    ],
    []
  );
  const columns = React.useMemo(
    () => [
      {
        Header: "Account No",
        accessor: "number",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Client Account Name",
        accessor: "account_name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Store",
        accessor: "store_name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Contact No.",
        accessor: "phone_numbers",
        disableSortBy: true,
        Cell: ({ value }) => {
          const defaultPhone = value?.find((data) => data.is_default === 1);
          const extraPhones = value?.filter((data) => data !== defaultPhone);

          return (
            <Stack
              sx={{
                flexDirection: "row",
                gap: "8px",
                flexWrap: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {defaultPhone && (
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {defaultPhone.phone}
                </div>
              )}

              {extraPhones?.length > 0 && (
                <Tooltip
                  title={
                    <Box component="ul" sx={{ margin: 0, padding: '4px 8px', listStyle: 'none' }}>
                      {extraPhones.map((data, index) => (
                        <li key={index}>{data.phone}</li>
                      ))}
                    </Box>
                  }
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#192029',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#192029',
                      },
                    },
                  }}
                  arrow
                >
                  <Chip
                    sx={{ borderRadius: "8px", flexShrink: 0 }}
                    label={`+${extraPhones.length}`}
                    variant="filled"
                    size="small"
                  />
                </Tooltip>
              )}
            </Stack>
          );
        },
      },
      {
        Header: "Email ID",
        accessor: "emails",
        disableSortBy: true,
        Cell: ({ value }) => {
          const defaultEmail = value?.find((data) => data.is_default === 1);
          const extraEmail = value?.filter((data) => data !== defaultEmail);

          return (
            <Stack
              sx={{
                flexDirection: "row",
                gap: "8px",
                flexWrap: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }}
            >
              {defaultEmail && (
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {defaultEmail.email}
                </div>
              )}

              {extraEmail?.length > 0 && (
                <Tooltip
                  title={
                    <Box component="ul" sx={{ margin: 0, padding: '4px 8px', listStyle: 'none' }}>
                      {extraEmail.map((data, index) => (
                        <li key={index}>{data.email}</li>
                      ))}
                    </Box>
                  }
                  slotProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#192029',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#192029',
                      },
                    },
                  }}
                  arrow
                >
                  <Chip
                    sx={{ borderRadius: "8px", flexShrink: 0 }}
                    label={`+${extraEmail.length}`}
                    variant="filled"
                    size="small"
                  />
                </Tooltip>
              )}
            </Stack>
          );
        },
      },

      {
        Header: "Credit Limit",
        accessor: "credit_limit",
        Cell: ({ value }) => {
          return <div>{formatAmount(value)}</div>;
        },
      },
      {
        Header: "Total Due Amount",
        accessor: "due_amount",
        Cell: ({ value }) => {
          return <div>{formatAmount(value)}</div>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        sortInverted: true,
        Cell: ({ value }) => {
          return value ? (
            <Chip
              label="Active"
              color="success"
              variant="outlined"
              size="small"
            />
          ) : (
            <Chip
              label="Inactive"
              color="success"
              variant="outlined"
              size="small"
              disabled
            />
          );
        },
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableGlobalFilter: true,
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons id={row.id} />;
        },
      },
    ],
    []
  );
  const options = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];
  const comparisonOperators = [
    { label: "Greater than", value: ">" },
    { label: "Greater than or Equal to", value: ">=" },
    { label: "Less than", value: "<" },
    { label: "Less than or Equal to", value: "<=" },
    { label: "Equal to", value: "=" },
  ];
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: (option) => option.label,
  });

  const hascreditLimitOperator =
    state.filters.credit_limit_value.value &&
    !state.filters.credit_limit_operator.value;
  const hascreditLimitValue =
    state.filters.credit_limit_operator.value &&
    !state.filters.credit_limit_value.value;
  const hasdueLimitOperator =
    state.filters.due_amount_operator.value &&
    !state.filters.due_amount_value.value;
  const hasdueLimitValue =
    state.filters.due_amount_value.value &&
    !state.filters.due_amount_operator.value;

  const tabs = React.useMemo(() => {
    return [
      {
        label: "Accounts",
        value: "1",
        panel: (
          <CustomTable
            columns={isStoreAdmin ? storeAdmincolumns : columns}
            data={dataList}
            isLoading={isLoading}
            searchBar={true}
            rowsSelection={false}
            defaultSearch={false}
            filterApplied={state.filters.all}
            tableId="client-account"
            onFilterClear={(e) => handleFilterClear("single", e)}
            onAllFilterClear={(e) => handleFilterClear("all")}
            filterContent={
              <>
                <InputControl
                  type="table-search"
                  value={state.filters.searchText}
                  onChange={(e) => onChangeFilter(e)}
                  onClear={onSeachClear}
                />

                {isCreateVisible && (
                  <Button
                    type="button"
                    size="medium"
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{ minWidth: "fit-content" }}
                    onClick={() => {
                      isStoreAdmin
                        ? navigate(`/store-admin/client-account-v2/create`)
                        : navigate(`/client-account-v2/create`);
                    }}
                  >
                    Add New
                  </Button>
                )}
              </>
            }
            filterSection={
              <>
                <Stack
                  direction="row"
                  gap="16px"
                  alignItems="center"
                  flexWrap="wrap"
                >
                  {!isStoreAdmin && (
                    <InputControl
                      type="dropdown"
                      name="store"
                      label="Store"
                      multiple={true}
                      options={arraySort(storeOptions || [], "label")}
                      value={state.filters.stores}
                      disableCloseOnSelect
                      disableClearable={true}
                      onChange={(e, v) => handleFilter(e, v, "store")}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => <></>)
                      }
                      renderOption={(props, option, { selected }) => (
                        <li {...props} key={option.value}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.label}
                        </li>
                      )}
                      filterOptions={filterOptions}
                      sx={{ width: 250 }}
                      componentsProps={{
                        paper: {
                          sx: {
                            width: "fit-content",
                            minWidth: 250,
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Store"
                          placeholder="Store"
                        />
                      )}
                    />
                  )}
                  <Stack direction="column">
                    <FormGroup row>
                      <InputControl
                        type="select"
                        name="credit_limit_operator"
                        label="Credit Limit"
                        placeholder="Credit Limit"
                        optionValue={comparisonOperators}
                        value={state.filters.credit_limit_operator?.value ?? ""}
                        width="150px"
                        onChange={(e, v) =>
                          handleFilter(e, v, "credit_limit_operator")
                        }
                        sx={{
                          borderRadius: "8px 0 0 8px",
                        }}
                      />

                      <InputControl
                        label="Value"
                        type="number"
                        name="credit_limit_value"
                        value={state.filters.credit_limit_value?.value ?? ""}
                        onChange={(e, v) =>
                          handleFilter(e.target.value, v, "credit_limit_value")
                        }
                        width="99px"
                        sx={{
                          ".MuiInputBase-root": {
                            borderRadius: "0 8px 8px 0px",
                          },
                        }}
                      />
                    </FormGroup>
                    <Box sx={{ color: "#cf443d" }}>
                      {hascreditLimitValue ? (
                        <Typography sx={{ color: "#cf443d" }}>
                          The value field is required
                        </Typography>
                      ) : (
                        ""
                      )}
                      {hascreditLimitOperator ? (
                        <Typography sx={{ color: "#cf443d" }}>
                          The credit limit field is required
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Box>
                  </Stack>
                  <Stack direction="column">
                    <FormGroup row>
                      <InputControl
                        type="select"
                        name="due_amount_operator"
                        value={state.filters.due_amount_operator?.value ?? ""}
                        label="Due Amount"
                        placeholder="Due Amount"
                        optionValue={comparisonOperators}
                        width="150px"
                        onChange={(e, v) =>
                          handleFilter(e, v, "due_amount_operator")
                        }
                        sx={{
                          borderRadius: "8px 0 0 8px",
                        }}
                      />

                      <InputControl
                        label="Value"
                        name="due_amount_value"
                        type="number"
                        value={state.filters.due_amount_value?.value ?? ""}
                        onChange={(e, v) =>
                          handleFilter(e.target.value, v, "due_amount_value")
                        }
                        width="99px"
                        sx={{
                          ".MuiInputBase-root": {
                            borderRadius: "0 8px 8px 0px",
                          },
                        }}
                      />
                    </FormGroup>
                    <Box sx={{ color: "#cf443d" }}>
                      {hasdueLimitOperator ? (
                        <Typography sx={{ color: "#cf443d" }}>
                          The value field is required
                        </Typography>
                      ) : (
                        ""
                      )}
                      {hasdueLimitValue ? (
                        <Typography sx={{ color: "#cf443d" }}>
                          The Due Amount field is required
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Box>
                  </Stack>
                  <InputControl
                    type="select"
                    name="Status"
                    label="Status"
                    value={state.filters.status.value ?? ""}
                    optionValue={options}
                    width="100px"
                    sx={{
                      width: "120px",
                    }}
                    onChange={(e, v) => handleFilter(e, v, "status")}
                  />
                </Stack>
                <Button
                  type="button"
                  size="medium"
                  variant="text"
                  color="info"
                  sx={{
                    minWidth: "40px",
                    p: "8px",
                  }}
                  onClick={() => handleApplyFilter()}
                  disabled={
                    hascreditLimitOperator ||
                    hascreditLimitValue ||
                    hasdueLimitOperator ||
                    hasdueLimitValue
                  }
                >
                  Apply
                </Button>
              </>
            }
            onRowAction={(e) => {
              navigate(`details/${e.id}`);
            }}
          />
        ),
      },
      {
        // label: (
        //   <Stack
        //     pr="4px"
        //     flexDirection="row"
        //     alignItems="center"
        //     justifyContent="center"
        //     gap={1}
        //   >
        //     Manage Requests
        //     <Box
        //       sx={{
        //         px: 1,
        //         py: 0.7,
        //         backgroundColor: "info.main",
        //         borderRadius: 50,
        //         color: "#fff",
        //         fontSize: 12,
        //       }}
        //     >
        //       12
        //     </Box>
        //   </Stack>
        // ),
        label: "Manage Requests",
        value: "2",
        panel: <ClientAccountRequestList />,
      },
    ];
  }, [
    isStoreAdmin,
    storeAdmincolumns,
    columns,
    dataList,
    state?.isBusy,
    state.filters.all,
    state.filters.searchText,
    state.filters.stores,
    state.filters.credit_limit_operator?.value,
    state.filters.credit_limit_value?.value,
    state.filters.due_amount_operator?.value,
    state.filters.due_amount_value?.value,
    state.filters.status.value,
    isCreateVisible,
    storeOptions,
    comparisonOperators,
    hascreditLimitValue,
    hascreditLimitOperator,
    hasdueLimitOperator,
    hasdueLimitValue,
    options,
  ]);

  return (
    <ContentLayout
      title="Client Account"
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[{ name: "Dashboard", href: "/" }, { name: "Client Account" }]}
        />
      }
      tabProps={{
        label: "generalTab",
        list: tabs,
      }}
    ></ContentLayout>
  );
};
